export function slugify(text) {
  return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
}

// Shared project-card markup. `hrefPrefix` adjusts the link base:
// '' on the projects listing (detail pages are siblings),
// 'projects/' on the main page.
export function renderProjectCard(p, hrefPrefix = '') {
  const cat = p.category.charAt(0).toUpperCase() + p.category.slice(1);
  const types = p.types || [];
  // Images live at the dist root. From the home page assets are siblings ('');
  // from /projects/index.html they're one level up ('../').
  const assetPrefix = hrefPrefix ? '' : '../';
  const coverSrc = /^https?:\/\//.test(p.cover || '') ? p.cover : `${assetPrefix}${p.cover}`;
  const coverPos = p.coverPosition ? ` style="object-position:${p.coverPosition}"` : '';
  const cover = p.cover
    ? `<div class="project-cover"><img src="${coverSrc}" alt="${p.title}" loading="lazy"${coverPos} /></div>`
    : '';
  return `
    <a class="project-card${p.cover ? ' has-cover' : ''}" href="${hrefPrefix}${slugify(p.title)}.html" data-cat="${cat}" data-types="${types.join(' ')}">
      ${cover}
      <div class="project-top">
        <span class="project-year">${p.year}</span>
        <div class="project-badges">
          <span class="project-cat">${cat.toUpperCase()}</span>
          ${types.map(t => `<span class="project-type">${t.toUpperCase()}</span>`).join('')}
        </div>
      </div>
      <h3 class="project-title">${p.title}</h3>
      <p class="project-blurb">${p.description}</p>
      <div class="project-tags">${p.tags.map(t => `<span class="project-tag">${t}</span>`).join('')}</div>
      <div class="project-highs">
        ${(p.highlights || []).map(h => `<div class="project-high">${h}</div>`).join('')}
      </div>
      <span class="project-read-more">READ MORE <span aria-hidden="true">→</span></span>
    </a>
  `;
}

// Compact card for the "Learning & coursework" group: title + meta + tags,
// with an optional cover image if `p.cover` is set.
export function renderCompactCard(p, hrefPrefix = '') {
  const cat = p.category.charAt(0).toUpperCase() + p.category.slice(1);
  const assetPrefix = hrefPrefix ? '' : '../';
  const coverSrc = /^https?:\/\//.test(p.cover || '') ? p.cover : `${assetPrefix}${p.cover}`;
  const coverPos = p.coverPosition ? ` style="object-position:${p.coverPosition}"` : '';
  const cover = p.cover
    ? `<div class="proj-compact-cover"><img src="${coverSrc}" alt="${p.title}" loading="lazy"${coverPos} /></div>`
    : '';
  return `
    <a class="proj-compact${p.cover ? ' has-cover' : ''}" href="${hrefPrefix}${slugify(p.title)}.html" data-cat="${cat}">
      ${cover}
      <div class="proj-compact-top">
        <span>${cat.toUpperCase()}</span>
        <span>${p.year}</span>
      </div>
      <h3 class="proj-compact-title">${p.title}</h3>
      <div class="proj-compact-tags">${p.tags.slice(0, 4).map(t => `<span class="project-tag">${t}</span>`).join('')}</div>
    </a>
  `;
}

export function renderMarkdown(text) {
  if (!text) return '';
  return text
    .trim()
    .replace(/^### (.+)$/gm, '<h4 class="writeup-h3">$1</h4>')
    .replace(/^## (.+)$/gm, '<h3 class="writeup-h2">$1</h3>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/`(.+?)`/g, '<code>$1</code>')
    .replace(/^- (.+)$/gm, '<li>$1</li>')
    .replace(/((?:<li>.*<\/li>\n?)+)/g, '<ul>$1</ul>')
    .replace(/\n\n/g, '<br><br>');
}